import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AgentConsole from "@/pages/AgentConsole";
import AdminDashboard from "@/pages/AdminDashboard";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Reschedule from "@/pages/Reschedule";
import { AuthCallback } from "@/components/AuthCallback";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/talk" element={<AgentConsole />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/reschedule/:token" element={<Reschedule />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#111111", border: "1px solid #2A2A2A", color: "#FFFFFF", borderRadius: "12px", fontFamily: "'Archivo', sans-serif", fontSize: "17px", fontWeight: 500 } }} />
    </div>
  );
}

export default App;
